"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderCardItem = exports.ListContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ListContainer = styled_1.default.div `
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  height: ${(props) => props.height
    ? typeof props.height === 'number'
        ? `${props.height}px`
        : props.height
    : 'auto'};
  overflow-y: auto;
`;
exports.ProviderCardItem = styled_1.default.div `
  &:not(:last-child) {
    border-bottom: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_border')};
    padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }

  /* Focus indicator for keyboard navigation */
  &:focus {
    outline: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
`;
//# sourceMappingURL=MapProviderCardList.styles.js.map